<template>
  <div class="mymap">
    <MapView :clickRadius="false" :initialZoom="7"></MapView>
  </div>
</template>

<style></style>

<script>
import MapView from "@/components/MapView";

export default {
  name: "myMap",
  components: {
    MapView,
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scope>
.body-auth .app-auth-wrap {
  width: auto;
}

.app-header,
.map-wrap .map-meta,
.body-auth .app-auth-wrap .logo {
  display: none;
}

.map-wrap #map {
  height: 100vh;
}

.map-wrap {
  margin-top: 0;
}

.body-loggedin {
  padding-top: 0;
}
</style>